<ion-content class="edit-user">

  <app-header [title]="'Cost Center Assignment'"></app-header>

  <!-- Loader -->
  <div class="page-loader" *ngIf="!loaded">
    <ion-spinner></ion-spinner>
  </div>

  <form #ccForm="ngForm" >

    <input type="hidden" [(ngModel)]="selectedCC" name="hfdCC" />
        <ion-card class="center-card" >
          <ion-card-content>
            <ion-grid>
              <ion-row class="ion-align-items-center">
                <ion-col size="4"><strong>Customer</strong></ion-col>
                <ion-col size="8">{{ custDetail?.customerCode }}</ion-col>
              </ion-row>


              <ion-row class="ion-align-items-center">
                <ion-col size="4"><strong>Login</strong></ion-col>
                <ion-col size="8">{{ custDetail?.login }}</ion-col>
              </ion-row>


              <ion-row class="ion-align-items-center">
                <ion-col size="4"><strong>Name</strong></ion-col>
                <ion-col size="8">
                  {{ custDetail?.fname }} {{ custDetail?.lname }}
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-card-content>
        </ion-card>

   

    <ion-grid>
      <ion-row>
        <ion-col size="12" size-md="0.3"></ion-col>
        <ion-col size="12" size-md="5.3">
          <ion-card>
            <ion-card-header>
              <ion-card-title>Available Cost Center</ion-card-title>
            </ion-card-header>

            <ion-card-content>

            <ion-item class="search-item" lines="none" style="height:50px">
                <ion-input
                  [(ngModel)]="searchAvailable"
                  name="searchAvailable"
                  placeholder="Search Cost Center Name / Code"
                  clear-input="false"
                  (ionInput)="filterAvailable($event)"
                  (keydown.enter)="onEnterKeyAvailable($event)">
                </ion-input>

                <ion-button
                  slot="end"
                  color="gallaghergreen"
                  class="btn-box-shadow"
                  (click)="getCostCenterAvailable()">
                  Find
                </ion-button>

                <ion-button
                  slot="end"
                  fill="clear"
                  color="medium"
                  class="clear-btn"
                  (click)="clearAvailable()">
                  ✕
                </ion-button>
              </ion-item>

              <ion-item lines="none" class="cc-item">
                <ion-checkbox
                  slot="start"
                  [(ngModel)]="selectAllAvailable"
                  name="selectAllAvailable"
                  (ionChange)="toggleAllAvailable()">
                </ion-checkbox>
                <ion-label>Select All</ion-label>
              </ion-item>

              <ion-list class="cc-list">
                <ion-item *ngFor="let cc of filteredAvailable" class="cc-item">
                  <ion-checkbox
                    slot="start"
                     [checked]="selectedAvailable.has(cc.costCenterCode)"
                   (ionChange)="onAvaiCheckboxChange(cc.costCenterCode, $event.detail.checked)">
                  </ion-checkbox>

                  <ion-label>
                    {{ cc.costCenterCode }} - {{ cc.costCenterName }}
                  </ion-label>
                </ion-item>
              </ion-list>

            </ion-card-content>
          </ion-card>
        </ion-col>

       <ion-col
            size="12"
            size-md="0.8"
            class="center-buttons">

            <ion-button color="gallaghergreen" (click)="addCostCenter()"   title="Add Cost Center">
              &gt;&gt;
            </ion-button>

            <ion-button color="gallaghergreen" (click)="removeCostCenter()"   title="Remove Cost Center">
              &lt;&lt;
            </ion-button>

          </ion-col>
        <ion-col size="12" size-md="5.3">
          <ion-card>
            <ion-card-header>
              <ion-card-title>Assigned Cost Center</ion-card-title>
            </ion-card-header>

            <ion-card-content>

             
            <ion-item class="search-item" lines="none" style="height:50px">
                <ion-input
                  [(ngModel)]="searchAssigned"
                  name="searchAssigned"
                  placeholder="Search Cost Center Name / Code"
                  clear-input="false"
                  (ionInput)="filterAssigned($event)"
                  (keydown.enter)="onEnterKeyAssigned($event)">
                </ion-input>

                <ion-button
                  slot="end"
                  color="gallaghergreen"
                  class="btn-box-shadow"
                  (click)="getCostCenterAssigned()">
                  Find
                </ion-button>

                <ion-button
                  slot="end"
                  fill="clear"
                  color="medium"
                   class="clear-btn"
                  (click)="clearAssigned()" style="color:black">
                  ✕
                </ion-button>
              </ion-item>
              <ion-item lines="none" class="cc-item">
                <ion-checkbox
                  slot="start"
                  [(ngModel)]="selectAllAssigned"
                  name="selectAllAssigned"
                  (ionChange)="toggleAllAssigned()">
                </ion-checkbox>
                <ion-label>Select All</ion-label>
              </ion-item>

              <ion-list class="cc-list">
                <ion-item *ngFor="let cc of filteredAssigned" class="cc-item">
                  <ion-checkbox
                    slot="start"
                     [checked]="selectedAssigned.has(cc.costCenterCode)"
                     (ionChange)="onAssigCheckboxChange(cc.costCenterCode, $event.detail.checked)">
                  </ion-checkbox>

                  <ion-label>
                    {{ cc.costCenterCode }} - {{ cc.costCenterName }}
                  </ion-label>
                </ion-item>
              </ion-list>

            </ion-card-content>
          </ion-card>
        </ion-col>
        <ion-col size="12" size-md="0.3"></ion-col>
      </ion-row>
    </ion-grid>

  </form>

</ion-content>
